<div class="payment-progress-wrapper">
  <div class="payment-header position-relative mx-auto pl-3 pt-2 theme-light">
    <div class="text-center font-size-header font-weight-bold">{{'public.checkout.payment' | translate}}</div>
    <div class="payment-title d-block m-1 mt-3 text-center pb-2 font-size-primary theme-light-subtitle">
      {{'public.checkout.payUsingCard' | translate}}
    </div>
    <app-store-catalog-language-selector [haveBackground]="false"></app-store-catalog-language-selector>
  </div>
  <app-payment-progress-logo></app-payment-progress-logo>
</div>


